export function isNewFrontendRelease(current: string, manifest: unknown): boolean {
  const next = (manifest as { build_id?: unknown } | null)?.build_id;
  return typeof next === 'string' && next.length > 0 && next !== current;
}
